import React, { Component } from "react"
import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from "react-bootstrap"
import ActionButton from "../../ActionButton"
import { RunCancelPoolsMessages } from "../../../api/Randoms/RandomSelectionRun"

export interface RunCancelNotificationModalProps {
  notes: RunCancelPoolsMessages[]
  loading: boolean
  isConsortium: boolean
  confirmationText: string
  onSubmit: () => void
  onHide: () => void
}

export default class RunCancelNotificationModal extends Component<RunCancelNotificationModalProps> {

  render() {
    const { isConsortium, loading, onHide, confirmationText, notes, onSubmit } = this.props
    const messageRow = (note: RunCancelPoolsMessages, index: number) => {
      return <tr key={`notification_${index}`}>
        <td>{note.PoolName}</td>
        <td>{note.PoolCode}</td>
        <td>{note.Message}</td>
      </tr>
    }
    const showNotes = notes.length > 0

    return (
      <Modal backdrop="static" size={ showNotes ? "xl" : "sm" } centered show dialogClassName={loading ? "loading" : ""}>
        <Modal.Body>
          {!showNotes && !loading && <Row><Col><p>{confirmationText}</p></Col></Row>}
          {!showNotes && loading && <div className="text-center"><Spinner animation="border" variant="light" /></div>}
          {showNotes && <Container fluid style={{ height: "400px", overflowY: "scroll", overflowX: "hidden" }}>
              <Form.Group as={Row}>
                <Table responsive bordered className="dark text-center">
                  <thead>
                    <tr>
                      <th>{`${ isConsortium ? "Consortium" : "Pool" } Name`}</th>
                      <th>{`${ isConsortium ? "Consortium" : "Pool" } Code`}</th>
                      <th>Result message</th>
                    </tr>
                  </thead>
                  <tbody>{notes.map((note, i) => messageRow(note, i))}</tbody>
                </Table>
              </Form.Group>
          </Container>}
        </Modal.Body>
        {!loading && <Modal.Footer>
          {!showNotes && <Button variant="secondary" onClick={onHide} className="mr-auto fixed-w5">Cancel</Button>}
          {!showNotes && <ActionButton variant="primary" onClick={onSubmit} spin={loading} disableOnSpin className="fixed-w5">Confirm</ActionButton>}
          {showNotes && <Button variant="secondary" onClick={onHide} className="ml-auto fixed-w5">OK</Button>}
        </Modal.Footer>}
      </Modal>)
  }
}
